import React, { useEffect, useRef, useState, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Table } from 'semantic-ui-react';
import { getFromLocalStorage } from '../../../../../components/helper/authorizationHelper';
import { getAsync, postAsync } from '../../../../../components/helper/axiosHelper';
import { MDBBtn } from 'mdb-react-ui-kit';
import { PageHitCountApi } from '../../../../../shared/Helper';
import { useLocation } from 'react-use';
import { useSelector } from 'react-redux';
import LoadingAnimation from '../../../../../components/LoadingAnimation';
import Userbanner from '../../../../../components/elements/Userbanner';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PdfViewerModal from '../../../../../components/elements/PdfViewerModal';
import ImageViewModal from '../../../../../components/elements/ImageViewModal';
import '../gwaStyles.css';

const GWARegister = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [EpLicenceFile, setEP_License] = useState('');
  const [eP_Photo, setEP_Photo] = useState('');
  const [eP_ID, setEP_ID] = useState('');
  const [gwaTypeID, setGwaTypeID] = useState(1);
  const [regReason, setRegReason] = useState('');
  const [fullName, setFullName] = useState('');
  const [selectedImageData, setSelectedImageData] = useState('');
  const [workplace, setWorkplace] = useState('');
  const [ResidentCountryID, setResidentCountryID] = useState('');
  const [website, setWebsite] = useState('');
  const [EPLicenseBase64URL, setEPLicenseBase64URL] = useState('');
  const [eP_PhotoBase64URL, setEP_PhotoBase64URL] = useState('');
  const [EP_IDBase64URL, setEP_IDBase64URL] = useState('');
  const [countryAPIData, setCountryAPIData] = useState([]);
  const [accountAPIData, setAccountAPIData] = useState([]);
  const [nationalityAPIData, setNationalityAPIData] = useState([]);
  const [selectedNationalityID, setSelectedNationalityID] = useState(null);
  const [allowedFileExtensions, setAllowedFileExtensions] = useState(['png', 'jpg', 'jpeg', 'pdf']);
  const [inputEP_IDFileSize, setInputEP_IDFileSize] = useState('');
  const [inputEP_PhotoFileSize, setInputEP_PhotoFileSize] = useState('');
  const [epUserID, setEpUserID] = useState(null);
  const [inputEP_LicenseFileSize, setInputEP_LicenseFileSize] = useState('');
  const [inputEP_IDFile, setinputEP_IDFile] = useState('');
  const [inputEP_PhotoFile, setInputEP_PhotoFile] = useState('');
  const [inputEP_LicenseFile, setInputEP_LicenseFile] = useState('');
  const [ep_IDCheck, setEP_IDcheck] = useState('');
  const [ep_PhotoCheck, setEp_PhotoCheck] = useState('');
  const [ep_LicenseCheck, setEp_LicenseCheck] = useState('');
  const [visible, setVisible] = useState(false);
  const [gridModalOpenEPID, setGridModalOpenEPID] = useState(false);
  const [gridModalOpenEPPhoto, setGridModalOpenEPPhoto] = useState(false);
  const [gridModalOpenEPLicense, setGridModalOpenEPLicense] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [accountHandelMappingList, setAccountHandelMappingList] = useState([]);
  const [websiteInputs, setWebsiteInputs] = useState([]);
  // const [siteIDs, setSiteIDs] = useState([]);
  // const [dynamicInput, setDynamicInput] = useState([]);
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const EP_IDInputRef = useRef();
  const EP_PhotoInputRef = useRef();
  const EP_LicenseInputRef = useRef();
  const token = localStorage.getItem('token');


  const isLogin = () => {
    if (!token && !epUserID) {
      navigate('/donorLogin');
    }
  };

  useLayoutEffect(() => {
    const getEPService = async () => {
      setIsLoad(true);
      try {
        const res = await postAsync('Utilities/EPUserServiceCheck', {}, { id: epUserID });
        if (res?.gwaServiceRegistered != 4) {
          navigate('/GWARegisterList');
        }
        setIsLoad(false);
      } catch (error) {
        setIsLoad(false);
        toast.error(t('Something went wrong, Please try again!'));
      }
    };
    if (epUserID !== null) {
      getEPService();
      PageHitCountApi(pathname, epUserID);
    }
  }, [epUserID]);

  const getPhotoBase64 = (EpPhotoFile) => {
    return new Promise((resolve) => {
      let baseURL = '';
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(EpPhotoFile);

      // on reader load something...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const getEP_IDBase64 = (eP_ID) => {
    return new Promise((resolve) => {
      let baseURL = '';
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(eP_ID);

      // on reader load something...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const getLicenseBase64 = (EpLicenceFile) => {
    return new Promise((resolve) => {
      let baseURL = '';
      // Make new FileReader
      let reader = new FileReader();

      // Convert the License to base64 text
      reader.readAsDataURL(EpLicenceFile);

      // on reader load something...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const handleLicense = (ePLicense) => {
    const inputEPLicenseFileExtension = ePLicense.target.files[0]?.name?.split('.').pop();
    const selectedFile = ePLicense.target.files[0];
    const fileSize = selectedFile.size;
    if (
      (inputEPLicenseFileExtension == 'jpg' ||
        inputEPLicenseFileExtension == 'png' ||
        inputEPLicenseFileExtension == 'jpeg' ||
        inputEPLicenseFileExtension == 'pdf') &&
      fileSize <= 2097152
    ) {
      setEp_LicenseCheck(inputEPLicenseFileExtension);
      let selectedPhoto = ePLicense.target.files[0];
      setInputEP_LicenseFile(selectedPhoto?.name?.substring(0, 100));
      if (selectedPhoto) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setInputEP_LicenseFileSize(fileSize);
        };
        reader.readAsDataURL(selectedPhoto);
      }

      if (allowedFileExtensions.includes(inputEPLicenseFileExtension) && inputEP_LicenseFileSize < 2097152) {
        getLicenseBase64(selectedPhoto)
          .then((result) => {
            selectedPhoto['base64'] = result;
            setEPLicenseBase64URL(result);
            setEP_License(selectedPhoto);
            toast.success(t('File uploaded successfully.'));
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else {
      EP_LicenseInputRef.current.value = '';
      setEPLicenseBase64URL('');
      setEP_License('');
      setInputEP_LicenseFileSize('');

      toast.error(
        t('Uploaded File must contain these formats [jpg, png, jpeg, pdf] and must not be greater than 2 MBs'),
      );
    }
  };

  const handleEP_ID = (eP_ID) => {
    const inputEP_IDFileExtension = eP_ID.target.files[0]?.name?.split('.').pop();
    const selectedFile = eP_ID.target.files[0];
    const fileSize = selectedFile.size;
    if (
      (inputEP_IDFileExtension == 'jpg' ||
        inputEP_IDFileExtension == 'png' ||
        inputEP_IDFileExtension == 'jpeg' ||
        inputEP_IDFileExtension == 'pdf') &&
      fileSize <= 2097152
    ) {
      setEP_IDcheck(inputEP_IDFileExtension);
      let selectedPhoto = eP_ID.target.files[0];
      setinputEP_IDFile(selectedPhoto.name?.substring(0, 100));
      if (selectedPhoto) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setInputEP_IDFileSize(fileSize);
        };
        reader.readAsDataURL(selectedPhoto);
      }

      if (allowedFileExtensions.includes(inputEP_IDFileExtension) && inputEP_IDFileSize < 2097152) {
        getEP_IDBase64(selectedPhoto)
          .then((result) => {
            selectedPhoto['base64'] = result;
            setEP_IDBase64URL(result);
            setEP_ID(selectedPhoto);
            toast.success(t('File uploaded successfully.'));
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else {
      EP_IDInputRef.current.value = '';
      setEP_IDBase64URL('');
      setEP_ID('');
      setInputEP_IDFileSize('');
      toast.error(
        t('Uploaded File must contain these formats [jpg, png, jpeg, pdf] and must not be greater than 2 MBs'),
      );
    }
  };

  const handleEP_Photo = (eP_Photo) => {
    const inputEP_PhotoFileExtension = eP_Photo.target.files[0]?.name?.split('.').pop();
    const selectedFile = eP_Photo.target.files[0];
    const fileSize = selectedFile.size;
    if (
      (inputEP_PhotoFileExtension == 'jpg' ||
        inputEP_PhotoFileExtension == 'png' ||
        inputEP_PhotoFileExtension == 'jpeg' ||
        inputEP_PhotoFileExtension == 'pdf') &&
      fileSize <= 2097152
    ) {
      setEp_PhotoCheck(inputEP_PhotoFileExtension);
      let selectedPhoto = eP_Photo.target.files[0];
      setInputEP_PhotoFile(selectedPhoto?.name?.substring(0, 100));
      if (selectedPhoto) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setInputEP_PhotoFileSize(fileSize);
        };
        reader.readAsDataURL(selectedPhoto);
      }

      if (allowedFileExtensions.includes(inputEP_PhotoFileExtension) && inputEP_PhotoFileSize < 2097152) {
        getPhotoBase64(selectedPhoto)
          .then((result) => {
            selectedPhoto['base64'] = result;
            setEP_PhotoBase64URL(result);
            setEP_Photo(selectedPhoto);
            toast.success(t('File uploaded successfully.'));
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else {
      EP_PhotoInputRef.current.value = '';
      setEP_PhotoBase64URL('');
      setEP_Photo('');
      setInputEP_PhotoFileSize('');
      toast.error(
        t('Uploaded File must contain these formats [jpg, png, jpeg, pdf] and must not be greater than 2 MBs'),
      );
    }
  };

  const validateSubmit = () => {
    let result = true;

    if (selectedNationalityID === '' || selectedNationalityID === null) {
      result = false;
      toast.warning(t('Please Select Nationality'));
    }
    // else if (ResidentCountryID === '' || ResidentCountryID === null) {
    //   result = false;
    //   toast.warning(t('Please Select Resident Country'));
    // }
    else if (EP_IDBase64URL === '' || EP_IDBase64URL === null) {
      result = false;
      toast.warning(t('Please Upload Donor file'));
    } else if (eP_PhotoBase64URL === '' || eP_PhotoBase64URL === null) {
      result = false;
      toast.warning(t('Please Upload Profile Picture'));
    } else if (EPLicenseBase64URL === '' || EPLicenseBase64URL === null) {
      result = false;
      toast.warning(t('Please Upload License'));
    } else if (accountHandelMappingList === '' || accountHandelMappingList === null) {
      result = false;
      toast.warning(t('Please Upload License '));
    } else if (website === '' || website === null) {
      result = false;
      toast.warning(t('Please Enter website link For Registering'));
    } else if (regReason === '' || regReason === null) {
      result = false;
      toast.warning(t('Please Enter Reason For Registering'));
    }
    // else if (accountHandelMappingList[0].siteID === '' || accountHandelMappingList[0].siteID === 0) {
    //   result = false;
    //   toast.warning(t('Please Account site Id For Registering'));
    // } else if (accountHandelMappingList[0].accountName === '' || accountHandelMappingList[0].accountName === null) {
    //   result = false;
    //   toast.warning(t('Please Account Links For Registering'));
    // }

    return result;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      let data = {
        gwaServiceID: 0,
        ePUserID: epUserID,
        gwaTypeID: gwaTypeID,
        ResidentCountryID: 208,
        NationalityID: selectedNationalityID,
        workplace,
        regReason,
        fullName,
        website,
        EP_IDBase64URL,
        eP_PhotoBase64URL,
        EPLicenseBase64URL,
        accountHandelMappingList: accountHandelMappingList.length != 0 ? accountHandelMappingList : [websiteInputs],
        EpPhotoFile: eP_Photo,
        eP_ID,
        EpLicenceFile,
      };

      if (validateSubmit()) {
        setIsLoad(true);
        await postAsync(
          'GWAService/CreateGWAService',
          data,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${token}`,
            },
          },
          'multipart/form-data',
        ).then((response) => {
          if (response?.statusCode === 200) {
            setIsLoad(false);
            toast.success(`${t('Registration successful. Waiting for approval.')}`);
            navigate('/GWARegisterList');
          } else {
            setIsLoad(false);
            toast.error(`${t('Something went wrong, Please try again!')}`);
          }
        });
      }
    } catch (error) {
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const getCountries = async () => {
    await getAsync('Utilities/GetCountryList')
      .then((response) => {
        setCountryAPIData(response?.data);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const getNationality = async () => {
    await getAsync('Utilities/GetNationalityList')
      .then((response) => {
        setNationalityAPIData(response?.data);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const handleOnSelectCountry = (selectedCountry) => {
    const id = selectedCountry.target.value;
    setResidentCountryID(id);
  };

  const getAccountsData = async () => {
    await getAsync('Utilities/GetAccountSiteList')
      .then((response) => {
        setAccountAPIData(response?.data);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const handleOnSelectNationality = (selectedNationality) => {
    const id = selectedNationality.target.value;
    setSelectedNationalityID(id);
  };

  useEffect(() => {
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });

    isLogin();
    getCountries();
    getNationality();
    getAccountsData();
  }, [epUserID]);

  const closeModal = (e) => {
    e.preventDefault();

    setGridModalOpenEPID(false);
    setGridModalOpenEPPhoto(false);
    setGridModalOpenEPLicense(false);
  };
  const openModalEPID = (e, eP_ID) => {
    e.preventDefault();
    if (ep_IDCheck != 'pdf') {
      const bas64 = eP_ID?.base64;
      setSelectedImageData(bas64);
      setGridModalOpenEPID(true);
    } else {
      setIsOpen(true);
    }
  };

  const openModalEPPhoto = (e, EpPhotoFile) => {
    e.preventDefault();
    if (ep_PhotoCheck != 'pdf') {
      const bas64 = EpPhotoFile?.base64;
      setEP_PhotoBase64URL(bas64);
      setGridModalOpenEPPhoto(true);
    } else {
      setIsOpen(true);
    }
  };

  const openModalEPLicense = (e, EpLicenceFile) => {
    e.preventDefault();
    if (ep_LicenseCheck != 'pdf') {
      const bas64 = EpLicenceFile?.base64;
      setSelectedImageData(bas64);
      setGridModalOpenEPLicense(true);
    } else {
      setIsOpen(true);
    }
  };

  const handleEP_IdDownload = async (e, file) => {
    e.preventDefault();
    const fileUrl = URL.createObjectURL(file);
    const downloadLink = document.createElement('a');
    downloadLink.href = fileUrl;
    downloadLink.download = file.name;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(fileUrl);
  };

  const handleEP_PhotoDownload = async (e, file) => {
    e.preventDefault();
    const fileUrl = URL.createObjectURL(file);
    const downloadLink = document.createElement('a');
    downloadLink.href = fileUrl;
    downloadLink.download = file.name;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(fileUrl);
  };

  const handleEP_LicenseDownload = async (e, file) => {
    e.preventDefault();
    const fileUrl = URL.createObjectURL(file);
    const downloadLink = document.createElement('a');
    downloadLink.href = fileUrl;
    downloadLink.download = file.name;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(fileUrl);
  };

  const handleEP_IdDelete = async (e) => {
    e.preventDefault();
    setEP_ID('');
    setInputEP_IDFileSize('');

    //setinputEP_IDFile('Uploaded File must contain these formats jpg png, jpeg, pdf and must not be greater than 2MBs.');
    EP_IDInputRef.current.value = '';
  };

  const handlePhotoDelete = async (e) => {
    e.preventDefault();
    setEP_Photo('');
    setInputEP_PhotoFileSize('');
    // setInputEP_PhotoFile(
    //   'Uploaded File must contain these formats jpg png, jpeg, pdf and must not be greater than 2MBs.',
    // );
    EP_PhotoInputRef.current.value = '';
  };
  const handleLicenseDelete = async (e) => {
    e.preventDefault('');
    setEP_License('');
    setInputEP_LicenseFileSize('');
    // setInputEP_LicenseFile(
    //   'Uploaded File must contain these formats jpg png, jpeg, pdf and must not be greater than 2MBs.',
    // );
    EP_LicenseInputRef.current.value = '';
  };

  const handleOnSelectAccountSite = (event, index) => {
    event.preventDefault();
    handleChange(event, 'siteID');
  };

  const handleAddRow = () => {
    if (websiteInputs.siteID && websiteInputs.accountName) {
      setAccountHandelMappingList((prev) => [...prev, websiteInputs]);
      setWebsiteInputs({
        siteID: '',
        accountName: '',
        siteName: '',
      });
    }
  };
  const handleDeleteRow = (e, index) => {
    e.preventDefault();
    const deleteVal = [...accountHandelMappingList];
    deleteVal.splice(index, 1);
    setAccountHandelMappingList(deleteVal);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    const selectedText = e.target.selectedOptions ? e.target.selectedOptions[0].text : '';

    // Update state based on the name (either 'siteIDs' or other fields)
    setWebsiteInputs((prev) => ({
      ...prev,
      [name]: value,
      siteName: name === 'siteID' ? selectedText : prev.siteName,
    }));
  };
  const toggleModal = () => {
    setIsOpen(!isOpen);
  };
  // const handleChange = (e, field) => {
  //   e.preventDefault();
  //   console.log(field , "fieldfieldfield")
  //   const {name, value } = e.target;
  //   console.log(value,name, "newvalueee")
  //   const onChangeVal = [...accountHandelMappingList];
  //   console.log(onChangeVal, "onChangeVal")
  //   onChangeVal[name][field] = value;
  //   setAccountHandelMappingList(onChangeVal);
  // };

  return (
    <div className=" pt-12">
      <Userbanner />
      {isLoad ? (
        <LoadingAnimation imageStyling={''} styling={'flex items-center py-5 align-middle justify-center space-x-2'} />
      ) : (
        <div className="col-xl-12 pb-5">
          <form>
            <div className="card lg:px-3">
              <div className="card-header text-center">
                <h1 className="font-bold sm:text-2xl  text-xl text-customgreen"> {t('Registration')}</h1>
              </div>

              <div className="card-body ">
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                    <h2 className="text-gray-800 font-bold text-pretty text-md">{t('Personal Details')}</h2>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography></Typography>
                    <div className="row">
                      {/* <div className="col-lg-6 ">
                        <div className="form-group ">
                          <label>
                            {t('User Type')} <span className="errmsg">*</span>
                          </label>
                          <br />
                          <label

                              className="text-gray-700   text-pretty text-sm"
                            >
                            <input

                               className="w-4 h-4  border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen m-3 block"
                              type="radio"
                              defaultChecked
                              name="userType"
                              value={1}
                              onClick={() => {
                                setVisible(false);
                                setGwaTypeID(1);
                              }}
                            />
                            {t('Institute')}
                          </label>
                          <label

                              className="text-gray-700  text-pretty text-sm"
                            >
                            <input

                              type="radio"
                               className="w-4 h-4  border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen m-3 block"
                              name="userType"
                              value={2}
                              onClick={() => {
                                setVisible(true);
                                setGwaTypeID(2);
                              }}
                            />
                            {t('Personal')}
                          </label>
                        </div>
                      </div> */}

                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>
                            {t('User Type')} <span className="errmsg">*</span>
                          </label>
                          <br />
                          <div className="flex space-x-6 px-1 my-2">
                            {' '}
                            {/* Flex to align inputs in a row */}
                            <label className="block">
                              <input
                                className="w-4 h-4 mb-1 border border-gray-300 text-customgreen rounded-lg focus:ring-customgreen focus:border-customgreen"
                                type="radio"
                                defaultChecked
                                name="userType"
                                value={1}
                                onClick={() => {
                                  setVisible(false);
                                  setGwaTypeID(1);
                                }}
                              />
                              <span className="block mt-2 ">{t('Institute')}</span> {/* Label below */}
                            </label>
                            <label className="block">
                              <input
                                className="w-4 h-4 mb-1 border border-gray-300 text-customgreen rounded-lg focus:ring-customgreen focus:border-customgreen"
                                type="radio"
                                name="userType"
                                value={2}
                                onClick={() => {
                                  setVisible(true);
                                  setGwaTypeID(2);
                                }}
                              />
                              <span className="block mt-2 ">{t('Personal')}</span> {/* Label below */}
                            </label>
                          </div>
                        </div>
                      </div>

                      {visible && (
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>
                              {t('Workplace')}
                              <span className="errmsg">*</span>
                            </label>
                            <input
                              onChange={(e) => setWorkplace(e.target.value)}
                              type="text"
                              className="w-full mt-1 text-xss lg:text-base p-2 border rounded-md text-gray-600 focus:ring-2 focus:ring-customgreen"
                              placeholder={t('Workplace')}
                              minLength="1"
                              maxLength="50"
                            />
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="row">
                      <div className="col-lg-6 ">
                        <div className="form-group">
                          <label>
                            {t('Nationality')} <span className="errmsg">*</span>
                          </label>
                          <select
                            value={selectedNationalityID}
                            onChange={(selectedNationalityID) => handleOnSelectNationality(selectedNationalityID)}
                            className="w-full mt-1 text-xss lg:text-base p-2 border rounded-md text-gray-600 focus:ring-2 focus:ring-customgreen"
                          >
                            <option value="0">--{t('Select')}--</option>
                            {nationalityAPIData && nationalityAPIData.length > 0 ? (
                              nationalityAPIData?.map((item) => (
                                <option key={item.settingsNationalityID} value={item.settingsNationalityID}>
                                  {isActive ? item?.nationality_t : item.nationality_eng}
                                </option>
                              ))
                            ) : (
                              <option>{t('No country found')}</option>
                            )}
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>
                            {t('Resident Country')}
                            <span className="errmsg">*</span>
                          </label>
                          <select
                            disabled
                            value={ResidentCountryID}
                            // onChange={(selectedCountryID) => handleOnSelectCountry(selectedCountryID)}
                            className="w-full mt-1 text-xss lg:text-base p-2 border rounded-md text-gray-600 focus:ring-2 focus:ring-customgreen"
                          >
                            {/* <option value="0">--{t('Select')}--</option> */}
                            {countryAPIData && countryAPIData.length > 0 ? (
                              countryAPIData?.map((item) => (
                                <option key={item.countryID} value={item.countryID}>
                                  {isActive ? item?.ar_SA : item.countryName}
                                </option>
                              ))
                            ) : (
                              <option>{t('No country found')}</option>
                            )}
                          </select>
                        </div>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <br />

                <Accordion className="">
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                    <h2 className="text-gray-800 font-bold text-pretty text-md">{t('Document Upload')}</h2>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group ">
                          <label className="text-gray-700 p-2 text-pretty text-sm">
                            {t('Donor ID')}
                            <span className="errmsg">*</span>
                          </label>
                          <input
                            accept=".png, .jpeg, .jpg, .pdf"
                            onChange={handleEP_ID}
                            type="file"
                            className="w-full mt-1  border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  block"
                            ref={EP_IDInputRef}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 ">
                        <br />
                        {allowedFileExtensions.includes(ep_IDCheck) &&
                          inputEP_IDFileSize <= 2097152 &&
                          inputEP_IDFileSize != '' && (
                            <Table className="text-sm text-left rtl:text-right ">
                              <Table.Header className="text-xs text-white bg-customgreen uppercase">
                                <Table.Row>
                                  <Table.Cell className="text-white">{t('sNo')}</Table.Cell>
                                  <Table.Cell className="text-white">{t('File')}</Table.Cell>
                                  <Table.Cell className="text-white">{t('Action')}</Table.Cell>
                                </Table.Row>
                              </Table.Header>
                              <Table.Body>
                                <Table.Row>
                                  <Table.Cell>1</Table.Cell>
                                  <Table.Cell>
                                    <label
                                    // style={{
                                    //   color: 'red',
                                    //   fontWeight: '500',
                                    // }}
                                    >
                                      {/* {t(
                                        'Uploaded File must contain these formats [jpg, png, jpeg, pdf]and must not be greater than 2 MBs',
                                      )} */}
                                      {inputEP_IDFile}
                                    </label>
                                  </Table.Cell>
                                  <Table.Cell>
                                    <button
                                      className="focus:outline-none text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium rounded-full  text-sm px-5 py-2.5 me-2 mb-2 dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                                      onClick={(e) => handleEP_IdDownload(e, eP_ID)}
                                      style={{
                                        margin: '5px',
                                      }}
                                    >
                                      <FileDownloadOutlinedIcon />
                                    </button>{' '}
                                    {/* Modal Create */}
                                    <>
                                      <MDBBtn
                                        className="focus:outline-none text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium rounded-full  text-sm px-5 py-2.5 me-2 mb-2 dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                                        onClick={(e) => openModalEPID(e, eP_ID)}
                                        style={{
                                          margin: '5px',
                                        }}
                                      >
                                        <VisibilityOutlinedIcon />
                                      </MDBBtn>

                                      {ep_IDCheck != 'pdf' ? (
                                        // <MDBModal show={gridModalOpenEPID} setShow={setGridModalOpenEPID}>
                                        //   <MDBModalDialog>
                                        //     <MDBModalContent>
                                        //       <MDBModalHeader>
                                        //         <MDBModalTitle className="text-customgreen">
                                        //           {t('Donor ID')}
                                        //         </MDBModalTitle>
                                        //         <MDBBtn
                                        //           type="button"
                                        //           className="btn-close"
                                        //           color="none"
                                        //           onClick={(e) => closeModal(e)}
                                        //         ></MDBBtn>
                                        //       </MDBModalHeader>
                                        //       <MDBModalBody>
                                        //         <div className="container-fluid bd-example-row">
                                        //           {selectedImageData && (
                                        //             <img
                                        //               style={{
                                        //                 height: '250px',
                                        //                 width: '450px',
                                        //               }}
                                        //               src={`${selectedImageData}`}
                                        //               alt="img.jpg"
                                        //             />
                                        //           )}
                                        //         </div>
                                        //       </MDBModalBody>
                                        //       <MDBModalFooter>
                                        //         <MDBBtn
                                        //           className="text-white hover:text-white bg-customgreen border-2 border-customgreen hover:bg-hovergreen focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-full text-sm px-4 py-2 text-center me-2"
                                        //           onClick={(e) => closeModal(e)}
                                        //         >
                                        //           {t('close')}
                                        //         </MDBBtn>
                                        //       </MDBModalFooter>
                                        //     </MDBModalContent>
                                        //   </MDBModalDialog>
                                        // </MDBModal>
                                        <ImageViewModal
                                          showModal={gridModalOpenEPID}
                                          setShowModal={setGridModalOpenEPID}
                                          closeModal={closeModal}
                                          title={'Donor ID'}
                                          renderLink={selectedImageData}
                                        />
                                      ) : (
                                        isOpen && (
                                          <PdfViewerModal
                                            pdfBase64={EP_IDBase64URL}
                                            toggleModal={toggleModal}
                                            visible={true}
                                          />
                                        )
                                      )}
                                    </>
                                    {/* end */}
                                    <button
                                      className="focus:outline-none text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium rounded-full  text-sm px-5 py-2.5 me-2 mb-2 dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                                      style={{
                                        margin: '5px',
                                      }}
                                      onClick={(e) => handleEP_IdDelete(e, eP_ID)}
                                    >
                                      <DeleteOutlinedIcon />
                                    </button>
                                  </Table.Cell>
                                </Table.Row>
                              </Table.Body>
                            </Table>
                          )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label>
                            {t('Profile Picture')} <span className="errmsg">*</span>
                          </label>
                          <input
                            accept=".png, .jpeg, .jpg, .pdf"
                            onChange={handleEP_Photo}
                            type="file"
                            className="w-full mt-1  border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  block"
                            ref={EP_PhotoInputRef}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <br />
                      {allowedFileExtensions.includes(ep_PhotoCheck) &&
                        inputEP_PhotoFileSize <= 2097152 &&
                        inputEP_PhotoFileSize != '' && (
                          <Table className="text-sm text-left rtl:text-right ">
                            <Table.Header className="text-xs text-white bg-customgreen uppercase bg-gray-50 ">
                              <Table.Row>
                                <Table.Cell className="text-white">{t('sNo')}</Table.Cell>
                                <Table.Cell className="text-white">{t('File')}</Table.Cell>
                                <Table.Cell className="text-white">{t('Action')}</Table.Cell>
                              </Table.Row>
                            </Table.Header>
                            <Table.Body>
                              <Table.Row>
                                <Table.Cell>1</Table.Cell>
                                <Table.Cell>
                                  <label
                                  // style={{
                                  //   color: 'red',
                                  //   fontWeight: '500',
                                  // }}
                                  >
                                    {inputEP_PhotoFile}
                                  </label>
                                </Table.Cell>
                                <Table.Cell>
                                  <button
                                    className="focus:outline-none text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium rounded-full  text-sm px-5 py-2.5 me-2 mb-2 dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                                    onClick={(e) => handleEP_PhotoDownload(e, eP_Photo)}
                                    style={{
                                      margin: '5px',
                                    }}
                                  >
                                    <FileDownloadOutlinedIcon />
                                  </button>{' '}
                                  {/* Modal Create */}
                                  <>
                                    <MDBBtn
                                      className="focus:outline-none text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium rounded-full  text-sm px-5 py-2.5 me-2 mb-2 dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                                      onClick={(e) => openModalEPPhoto(e, eP_Photo)}
                                      style={{
                                        margin: '5px',
                                      }}
                                    >
                                      <VisibilityOutlinedIcon />
                                    </MDBBtn>

                                    {ep_PhotoCheck != 'pdf' ? (
                                      // <MDBModal
                                      //   tabIndex="-1"
                                      //   show={gridModalOpenEPPhoto}
                                      //   setShow={setGridModalOpenEPPhoto}
                                      // >
                                      //   <MDBModalDialog>
                                      //     <MDBModalContent>
                                      //       <MDBModalHeader>
                                      //         <MDBModalTitle className="text-customgreen">
                                      //           {t('Profile Picture')}
                                      //         </MDBModalTitle>
                                      //         <MDBBtn
                                      //           type="button"
                                      //           className="btn-close"
                                      //           color="none"
                                      //           onClick={(e) => closeModal(e)}
                                      //         ></MDBBtn>
                                      //       </MDBModalHeader>
                                      //       <MDBModalBody>
                                      //         <div className="container-fluid bd-example-row">
                                      //           {selectedImageData && (
                                      //             <img
                                      //               style={{
                                      //                 height: '250px',
                                      //                 width: '450px',
                                      //               }}
                                      //               src={`${eP_PhotoBase64URL}`}
                                      //               alt="img.jpg"
                                      //             />
                                      //           )}
                                      //         </div>
                                      //       </MDBModalBody>
                                      //       <MDBModalFooter>
                                      //         <MDBBtn
                                      //           className="text-white hover:text-white bg-customgreen border-2 border-customgreen hover:bg-hovergreen focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-full text-sm px-4 py-2 text-center me-2"
                                      //           onClick={closeModal}
                                      //         >
                                      //           {t('close')}
                                      //         </MDBBtn>
                                      //       </MDBModalFooter>
                                      //     </MDBModalContent>
                                      //   </MDBModalDialog>
                                      // </MDBModal>
                                      <ImageViewModal
                                        showModal={gridModalOpenEPPhoto}
                                        setShowModal={setGridModalOpenEPPhoto}
                                        closeModal={closeModal}
                                        title={'Profile Picture'}
                                        renderLink={eP_PhotoBase64URL}
                                      />
                                    ) : (
                                      isOpen && (
                                        <PdfViewerModal
                                          pdfBase64={eP_PhotoBase64URL}
                                          toggleModal={toggleModal}
                                          visible={true}
                                        />
                                      )
                                    )}
                                  </>
                                  {/* end */}
                                  <button
                                    className="focus:outline-none text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium rounded-full  text-sm px-5 py-2.5 me-2 mb-2 dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                                    style={{
                                      margin: '5px',
                                    }}
                                    onClick={(e) => handlePhotoDelete(e, eP_Photo)}
                                  >
                                    <DeleteOutlinedIcon />
                                  </button>
                                </Table.Cell>
                              </Table.Row>
                            </Table.Body>
                          </Table>
                        )}
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label>
                            {t('License')} <span className="errmsg">*</span>
                          </label>
                          <input
                            accept=".png, .jpeg, .jpg, .pdf"
                            onChange={handleLicense}
                            type="file"
                            className="w-full mt-1  border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  block"
                            ref={EP_LicenseInputRef}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <br />
                        {allowedFileExtensions.includes(ep_LicenseCheck) &&
                          inputEP_LicenseFileSize <= 2097152 &&
                          inputEP_LicenseFileSize != '' && (
                            <Table className="text-sm text-left rtl:text-right ">
                              <Table.Header className="text-xs text-white bg-customgreen uppercase bg-gray-50 ">
                                <Table.Row>
                                  <Table.Cell className="text-white">{t('sNo')}</Table.Cell>
                                  <Table.Cell className="text-white">{t('File')}</Table.Cell>
                                  <Table.Cell className="text-white">{t('Action')}</Table.Cell>
                                </Table.Row>
                              </Table.Header>
                              <Table.Body>
                                <Table.Row>
                                  <Table.Cell>1</Table.Cell>
                                  <Table.Cell>
                                    <label
                                    // style={{
                                    //   color: 'red',
                                    //   fontWeight: '500',
                                    // }}
                                    >
                                      {/* {t(
                                      'Uploaded File must contain these formats [jpg, png, jpeg, pdf]and must not be greater than 2 MBs',
                                    )}
                                    {inputEP_LicenseFileSize} -- {ep_LicenseCheck} */}
                                      {inputEP_LicenseFile}
                                    </label>
                                  </Table.Cell>
                                  <Table.Cell>
                                    <button
                                      className="focus:outline-none text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium rounded-full  text-sm px-5 py-2.5 me-2 mb-2 dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                                      onClick={(e) => handleEP_LicenseDownload(e, EpLicenceFile)}
                                      style={{
                                        margin: '5px',
                                      }}
                                    >
                                      <FileDownloadOutlinedIcon />
                                    </button>{' '}
                                    {/* Modal Create */}
                                    <>
                                      <MDBBtn
                                        className="focus:outline-none text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium rounded-full  text-sm px-5 py-2.5 me-2 mb-2 dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                                        onClick={(e) => openModalEPLicense(e, EpLicenceFile)}
                                        style={{
                                          margin: '5px',
                                        }}
                                      >
                                        <VisibilityOutlinedIcon />
                                      </MDBBtn>

                                      {ep_LicenseCheck != 'pdf' ? (
                                        // <MDBModal
                                        //   tabIndex="-1"
                                        //   show={gridModalOpenEPLicense}
                                        //   setShow={setGridModalOpenEPLicense}
                                        // >
                                        //   <MDBModalDialog>
                                        //     <MDBModalContent>
                                        //       <MDBModalHeader>
                                        //         <MDBModalTitle className="text-customgreen">
                                        //           {t('License')}
                                        //         </MDBModalTitle>
                                        //         <MDBBtn
                                        //           type="button"
                                        //           className="btn-close"
                                        //           color="none"
                                        //           onClick={(e) => closeModal(e)}
                                        //         ></MDBBtn>
                                        //       </MDBModalHeader>
                                        //       <MDBModalBody>
                                        //         <div className="container-fluid bd-example-row">
                                        //           {selectedImageData && (
                                        //             <img
                                        //               style={{
                                        //                 height: '250px',
                                        //                 width: '450px',
                                        //               }}
                                        //               src={`${EPLicenseBase64URL}`}
                                        //               alt="img.jpg"
                                        //             />
                                        //           )}
                                        //         </div>
                                        //       </MDBModalBody>
                                        //       <MDBModalFooter>
                                        //         <MDBBtn
                                        //           className="text-white hover:text-white bg-customgreen border-2 border-customgreen hover:bg-hovergreen focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-full text-sm px-4 py-2 text-center me-2"
                                        //           onClick={closeModal}
                                        //         >
                                        //           {t('close')}
                                        //         </MDBBtn>
                                        //       </MDBModalFooter>
                                        //     </MDBModalContent>
                                        //   </MDBModalDialog>
                                        // </MDBModal>
                                        <ImageViewModal
                                          showModal={gridModalOpenEPLicense}
                                          setShowModal={setGridModalOpenEPLicense}
                                          closeModal={closeModal}
                                          title={'Donor ID'}
                                          renderLink={EPLicenseBase64URL}
                                        />
                                      ) : (
                                        isOpen && (
                                          <PdfViewerModal
                                            pdfBase64={EPLicenseBase64URL}
                                            toggleModal={toggleModal}
                                            visible={true}
                                          />
                                        )
                                      )}
                                    </>
                                    {/* end */}
                                    <button
                                      className="focus:outline-none text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium rounded-full  text-sm px-5 py-2.5 me-2 mb-2 dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                                      style={{
                                        margin: '5px',
                                      }}
                                      onClick={(e) => handleLicenseDelete(e, EpLicenceFile)}
                                    >
                                      <DeleteOutlinedIcon />
                                    </button>
                                  </Table.Cell>
                                </Table.Row>
                              </Table.Body>
                            </Table>
                          )}
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <br />

                {/* aiforshare code start  */}

                {/* aiforshare code end */}

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                    <h2 className="text-gray-800 font-bold text-pretty text-md">{t('Account Details')}</h2>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography></Typography>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label>
                            {t('Website')} <span className="errmsg">*</span>
                          </label>
                          <input
                            value={website}
                            onChange={(e) => setWebsite(e.target.value)}
                            className="w-full  mt-1  border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  block"
                            placeholder={t('Website Link')}
                            minLength="1"
                            maxLength="100"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                    {/* new fields  */}
                    {/* { accountHandelMappingList.map((item, index) => ( */}
                    <div className="col-lg-12 ">
                      <div className="row flex py-1 align-middle items-center">
                        <div className="col-lg-6">
                          <label>
                            {t('Social Media Channel')} <span className="errmsg">*</span>
                          </label>
                          <select
                            value={websiteInputs.siteID}
                            name="siteID"
                            onChange={(event) => handleChange(event)}
                            className="w-full  mt-1  border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  block"
                          >
                            <option value="0">--{t('Select')}--</option>
                            {accountAPIData && accountAPIData.length > 0 ? (
                              accountAPIData?.map((accountItem, index) => (
                                <option key={index + 1} value={`${accountItem?.accountSiteID}`}>
                                  {t(accountItem?.name)}
                                </option>
                              ))
                            ) : (
                              <option>{t('No accounts found')}.</option>
                            )}
                          </select>
                        </div>
                        <div className="col-lg-6">
                          <label>
                            {t('Account Name')} <span className="errmsg">*</span>
                          </label>
                          <input
                            name="accountName"
                            type="text"
                            className="w-full   mt-1  border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  block"
                            value={websiteInputs.accountName}
                            onChange={(e) => handleChange(e, 'accountName')}
                          />
                        </div>
                        {/* <div className=" col-lg-2 d-flex justify-end ">
                                <button
                                  className="mt-4 focus:outline-none text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium rounded-full  text-sm px-5 py-2.5  dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                                  onClick={(e) => handleDeleteRow(e, index)}
                                >
                                  {t('Delete')}
                                </button>
                              </div> */}
                      </div>
                    </div>
                    {/* ))}   */}

                    <div className="row ">
                      <div className=" flex justify-center ">
                        {/* <button
                          className="w-36 m-2 mt-4 focus:outline-none text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium rounded-full  text-sm px-2 py-2.5 me-2  dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                          onClick={ (e) => handleAddRow(e) }
                        >
                          {t('Add Row')}
                        </button> */}

                        {/* Add button */}

                        <button
                          type="button"
                          onClick={() => handleAddRow()}
                          className="m-2 mt-4 text-customgreen border border-customgreen hover:bg-hovergreen hover:text-white focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-lg text-sm p-2.5 text-center inline-flex items-center me-2 dark:border-customgreen dark:text-customgreen dark:hover:text-white dark:focus:ring-customgreen dark:hover:bg-hovergreen"
                        >
                          <svg
                            className="w-5 h-5 transition-transform group-hover:rotate-45"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 18 18"
                          >
                            <path
                              stroke="currentColor"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M9 1v16M1 9h16"
                            ></path>
                          </svg>

                          <span className="sr-only">Icon description</span>
                        </button>
                      </div>
                      <div className="">
                        {/* new code start */}
                        {/* { dynamicInput.length > 0 && (
                  <table className="table-fixed w-full text-left">
                    <thead className="text-gray-200 uppercase bg-customgreen">
                      <tr>
                        <td className="py-1 border text-center font-bold p-4">{ t('Name') }</td>
                        <td className="py-1 border text-center font-bold p-4">{ t('Mobile') }</td>
                        <td className="py-1 border text-center font-bold p-4">{ t('Delete') }</td>
                      </tr>
                    </thead>
                    { dynamicInput.map((item, index) => (
                      <tbody className="text-gray-700" key={ index }>
                        <tr>
                          <td className="py-1 border text-center  p-4">{ item.beneName }</td>
                          <td className="py-1 border text-center  p-4">{ item.beneMobile }</td>
                          <td className="py-1 border text-center  p-4">
                            <button
                              className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2.5 text-center "
                              type="button"
                              onClick={ () => deleteTask(index) }
                            >
                              { t('Delete') }
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    )) }
                  </table>
                ) } */}

                        {/* new code end */}

                        {accountHandelMappingList.length > 0 && (
                          // <div className="col-lg-12 " key={index}>

                          //   <div className="row flex py-1 align-middle items-center">
                          //     <div className="col-lg-5">
                          //       <label>
                          //         {t('Social Media Channel')} <span className="errmsg">*</span>
                          //       </label>
                          //       <select
                          //         value={siteIDs[index]}
                          //         name="siteID"
                          //         onChange={(event) => handleOnSelectAccountSite(index, event)}
                          //         className="w-full  mt-1  border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  block"
                          //       >
                          //         <option value="0">--{t('Select')}--</option>
                          //         {accountAPIData && accountAPIData.length > 0 ? (
                          //           accountAPIData?.map((accountItem, index) => (
                          //             <option key={index + 1} value={accountItem?.accountSiteID}>
                          //               {t(accountItem?.name)}
                          //             </option>
                          //           ))
                          //         )
                          //         : (
                          //           <option>{t('No accounts found')}.</option>
                          //         )
                          //         }
                          //       </select>
                          //     </div>
                          //     <div className="col-lg-5">
                          //       <label>
                          //         {t('Account Name')} <span className="errmsg">*</span>
                          //       </label>
                          //       <input
                          //         name="accountName"
                          //         type="text"
                          //         className="w-full   mt-1  border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  block"
                          //         value={item.accountName}
                          //         onChange={(e) => handleChange(e, index, 'accountName')}
                          //       />
                          //     </div>
                          //     <div className=" col-lg-2 d-flex justify-end ">
                          //       <button
                          //         className="mt-4 focus:outline-none text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium rounded-full  text-sm px-5 py-2.5  dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                          //         onClick={(e) => handleDeleteRow(e, index)}
                          //       >
                          //         {t('Delete')}
                          //       </button>
                          //     </div>
                          //   </div>
                          // </div>

                          <div className="table-fixed  overflow-x-auto">
                            <table className="w-full text-center">
                              <thead className="text-gray-200 uppercase  text-sm bg-customgreen p-10">
                                <tr>
                                  <td className="py-1    font-bold ">{t('sNo')}</td>
                                  <td className="py-1   font-bold ">{t('Social Media Channel')}</td>
                                  <td className="py-1   font-bold ">{t('Account Name')}</td>
                                  <td className="py-1   font-bold ">{t('Delete')}</td>
                                </tr>
                              </thead>

                              {accountHandelMappingList.map((item, index) => (
                                <tbody className="text-gray-700" key={index}>
                                  <tr>
                                    <td className="py-1 p-4">{index + 1}</td>
                                    <td className="py-1 p-4">{item.siteName}</td>
                                    <td className="py-1 p-4">{item.accountName}</td>
                                    <td className="py-1 p-4">
                                      <button
                                        className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2.5 text-center "
                                        type="button"
                                        onClick={(e) => handleDeleteRow(e, index)}
                                      >
                                        {<DeleteOutlineIcon />}
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              ))}
                            </table>
                          </div>
                        )}

                        {/* <button
                          className="focus:outline-none text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium rounded-full  text-sm px-5 py-2.5 me-2 mb-2 dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                          onClick={(e) => handleConsoleLog(e, 0)}
                        >
                          Console Log Values at Index 0
                        </button> */}
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <br />

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                    <h2 className="text-gray-800 font-bold text-pretty text-md">{t('Extra')}</h2>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography></Typography>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label>
                            {t('Reason For Registering')} <span className="errmsg">*</span>
                          </label>
                          <textarea
                            style={{ height: '100px' }}
                            value={regReason}
                            onChange={(e) => setRegReason(e.target.value)}
                            className="w-full mt-1 text-xss lg:text-base p-2 border rounded-md text-gray-600 focus:ring-2 focus:ring-customgreen  "
                            minLength="1"
                            maxLength="1000"
                          />
                        </div>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
              <div className="card-footer flex text-center  justify-center flex-row items-center ">
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="focus:outline-none text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-4 py-2.5 me-2"
                >
                  {t('Register')}
                </button>

                <Link
                  to={'/GWARegisterList'}
                  className="text-white w-24 bg-customgreen ms-2 hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-8 py-2.5 text-center me-1"
                >
                  {t('Back')}
                </Link>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default GWARegister;
